import { Readings, Gateway } from "../../api"
import { auth, db } from '../../plugins/firebase'

const state = {
    list: [],
    collection: null,
    lastReadings: null,
    ready: false
};

const getters = {
    getMeter: state => meter => state.list.find( m => m.name === meter ),
    getMetersGtw: state => gateway => state.list.filter(m => m.gateway === gateway),
    getMeterData: state => meter => state.list.find(m => m.name === meter || m.circuit === meter).data,
    getLastReading: state => meter => state.lastReadings.find(m => m.meter === meter),
    getAll: state => state.list.map( m => ({ name: m.name, circuit: m.circuit })),
    getLocations: state => state.list.map( m => m.location )
};

const actions = {
    async init({ commit, dispatch, rootState }){
        return new Promise(async (resolve, reject) =>{
            if(auth.currentUser){
                commit('UPDATE_COLLECTION', rootState.account.id)
                await dispatch('fetchUserMeters')
                await dispatch('lastReadings')
                commit('SET_READY', true)
                return resolve()
            }else{
                commit('UPDATE_COLLECTION')
                commit('SET_METERS', [])
                return resolve()
            }
        })
    },
    async fetchUserMeters({ commit }){
        return new Promise(async (resolve, reject) =>{
            try {
                let response = await db.collection(state.collection).get()
                const meters = response.docs.map( m => m.data() )
                commit('SET_METERS', meters.map( m => 
                    m.hasOwnProperty('gain') ? m : { ...m, gain: 1 }
                ))
                return resolve()
            } catch (error) {
                commit('SET_METERS', [])
                return reject({ message: '¡Ops! Ocurrio un error' })
            }
        })
    },
    async addMeters({ state, commit }, data ){
        return new Promise(async (resolve, reject) => {
            try {
                let batch = db.batch()
                let meters = data.meters.map((m) =>{
                    m.gateway = data.gateway
                    batch.set(db.doc(`${state.collection}/${m.name}`) , m);
                    return m
                })
                await batch.commit()

                commit('ADD_METERS', meters)
                return resolve()
            } catch (error) {
                console.log(error)
                return reject({ message: '¡Ops! Ocurrio un error' })
            }
            

        })
    },
    editMeters({state, commit}, payload){
        const { meters, gateway } = payload
        return new Promise(async (resolve, reject) => {
            try {
                const requests = meters.map( m => db.doc(`${state.collection}/${m.name}`).update(m) )
                await Promise.all(requests)

                commit('UPDATE_METERS', meters)
                resolve()
            } catch (error) {
                reject()
            }
        })
    },
    deleteMeters({commit, state}, meters){
        return new Promise(async (resolve, reject) => {
            try {
                const requests = meters.map( m => db.doc(`${state.collection}/${m.name}`).delete() )
                let res = await Promise.all(requests)

                commit('DELETE_METERS', meters)
                resolve()
            } catch (error) {
                console.log(error)
                reject()
            }
        })
    },
    lastReadings({ state, commit }){
        return new Promise(async (resolve, reject) => {
            try {
                if(state.list.length == 0) return resolve()

                const { data } = await Readings.last(state.list.map((m) => m.name))
                const gains = state.list.reduce((object, meter) =>{
                    object[meter.name] = meter.gain
                    return object
                }, {})
                const meters = data.map( (record) => {
                    if(record.length === 0) return record[0]
                    record[0].lines.forEach( line =>{
                        line.amps = line.amps * gains[record[0].meter]
                        line.watts = line.watts * gains[record[0].meter]
                        line.kwht = line.kwht * gains[record[0].meter]
                    })
                    return record[0]
                })
                
                commit('UPDATE_LAST_READS', meters)
                return resolve()
            } catch (error) {
                console.log(error)
                return reject()
            }
            
        })
    },
    queryReadings({ state }, data){
        const meter = state.list.find((m) => m.name === data.meter);
        if(!meter) return []

        return new Promise((resolve, reject) => {
            Readings.byMeter(
                { id: meter.name, key: meter.key },
                data.query
            )
            .then((response) => {
                const { data } = response
                const readings = data.map( read => {
                    read.lines.forEach( line =>{
                        line.amps = line.amps * meter.gain
                        line.watts = line.watts * meter.gain
                        line.kwht = line.kwht * meter.gain
                    })
                    return read
                })
                resolve(readings)
            })
            .catch((error) => {
                console.log(error)
                reject(error)
            })
        })
    },
    getSummaryData({ state }, payload ){
        const hours = 1000 * 60 * 60
        let options = {
            start: new Date().setHours(0,0,0,0),
            end: new Date().setHours(0,0,0,0),
            action: ''
        }
        if( payload.type === 'week' ) {
            if(payload.options) options = payload.options
            else options.start = options.start - hours * 24 * 7
            options.action = 'daySummary'
        }
        else if( payload.type === 'month' ){
            if(payload.options) options = payload.options
            else options.start = options.start - hours * 24 * 30
            options.action = 'daySummary'
        } 
        else if( payload.type === 'day' ){
            options.action = 'hourSummary'
            if(payload.options) options.start = payload.options.start
        }
        else if( payload.type === 'custom' ){
            if(payload.options.type === 'hour') options.action = 'hourSummary'
            else if(payload.options.type === 'day') options.action = 'daySummary'
            options.end = payload.options.times.end.getTime()
            options.start = payload.options.times.start.getTime() 
        } 
        return new Promise(async (resolve, reject) => {
            const requests = payload.meters.map( m => 
                Readings[options.action](
                    m.name,
                    {
                        start: options.start, 
                        end: options.end
                    }
                )
            )
            try {
                let responses = await Promise.all(requests)
                const readings = responses.map((data, index) => {
                    const new_data = data.map( read => {
                        read.lines.forEach( line =>{
                            line.amps = line.amps * payload.meters[index].gain
                            line.watts = line.watts * payload.meters[index].gain
                            line.kwht = line.kwht * payload.meters[index].gain
                        })
                        return read
                    })
                    return new_data
                })
                return resolve(readings)
            } catch (error) {
                return reject(error)
            } 
        })
    }
};

const mutations = {
    UPDATE_COLLECTION(state, user){
        user 
            ? state.collection = `users_solar/${user}/meters`
            : state.collection = null
    },
    UPDATE_LAST_READS(state, data){
        state.lastReadings = data
    },
    SET_METER_DATA(state, payload) {
        const index = state.list.findIndex((m) => m.name == payload.meter);
        state.list[index].data = payload.data
        state.list[index].last_update = new Date().getTime()
    },
    DELETE_METERS(state, meters){
        meters.forEach(meter => {
            const index = state.list.findIndex((m) => m.name == meter.name);
            state.list.splice(index, 1)
        })
    },
    UPDATE_METERS(state, meters){
        meters.forEach(meter => {
            const index = state.list.findIndex((m) => m.name == meter.name);
            state.list[index] = meter
        })
    },
    SET_METERS(state, meters){
        if(!meters) return
        state.list = meters
    },
    ADD_METERS(state, meters) {
        if(!meters) return
        state.list.push(...meters)
    },
    SET_READY(state, payload){
        state.ready = payload
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
